import OrderedList from './OrderedList';
import Item from './Item';
OrderedList.Item = Item;
export { default as OrderedListItem } from './Item';
export default OrderedList;